import { Icon } from "@shopify/polaris"
import { PlayCircleIcon } from "@shopify/polaris-icons"
import classNames from "classnames"

import { parseYouTubeVideoId } from "@/pages/TrackingPage/ThemeLayoutCustomize/components/Layout/ThemeLayoutLeftTabPanels/youtubeUrlValidation"

import styles from "./index.module.scss"

export interface VideoBlockProps {
  /** 支持 watch、youtu.be、embed、shorts、live 等常见形态 */
  youtubeUrl: string
  /** iframe `title`，无障碍用 */
  title?: string
  cornerRadiusClass?: string
}

const VideoBlock = ({ title = "YouTube video", youtubeUrl, cornerRadiusClass }: VideoBlockProps) => {
  const videoId = parseYouTubeVideoId(youtubeUrl)
  const shellClass = classNames(
    "relative aspect-video w-full overflow-hidden",
    cornerRadiusClass,
    videoId ? "bg-black" : "bg-[#F1F1F1]",
  )

  if (!videoId) {
    return (
      <div className="w-full">
        <div aria-hidden className={shellClass}>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className={classNames(styles.iconWrapper, "flex h-12 w-12 items-center justify-center [&_svg]:h-12 [&_svg]:w-12")}>
              <Icon source={PlayCircleIcon} tone="subdued" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  const embedSrc = `https://www.youtube.com/embed/${videoId}?rel=0`

  return (
    <div className="w-full">
      <div className={shellClass}>
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="absolute left-0 top-0 h-full w-full border-0"
          referrerPolicy="strict-origin-when-cross-origin"
          src={embedSrc}
          title={title}
        />
      </div>
    </div>
  )
}

export default VideoBlock
